import * as LocationInspectionFormService from "../../services/locationInspectionServices/LocationInspectionFormService";
import { getAllEmployeesFromCompany } from "../../services/companiesServices/CompaniesEmployeesService";
import { getUserLocations } from "../../services/companiesServices/CompaniesLocationsService";
import { TYPES } from "../../util/Constants";

// ---------- LIST: GET /api/location-inspection-form ----------
export const getAllLocationInspectionFormsHandler = async (params) => {
  const response = await LocationInspectionFormService.getAllLocationInspectionForms(params);

  if (!response.ok) {
    return {
      data: {
        error: "Error getAllLocationInspectionFormsHandler",
        message: response.data?.message,
        page: null,
        items: [],
      },
    };
  }

  return {
    data: {
      error: null,
      page: response.data,
      items: response.data?.content || [],
    },
  };
};

// ---------- ME LIST: GET /api/location-inspection-form/me ----------
export const getMyLocationInspectionFormsHandler = async (params) => {
  const response = await LocationInspectionFormService.getMyLocationInspectionForms(params);

  if (!response.ok) {
    return {
      data: {
        error: "Error getMyLocationInspectionFormsHandler",
        message: response.data?.message,
        page: null,
        items: [],
      },
    };
  }

  return {
    data: {
      error: null,
      page: response.data,
      items: response.data?.content || [],
    },
  };
};

// ---------- CREATE: POST /api/location-inspection-form ----------
export const createLocationInspectionFormHandler = async (data) => {
  const body = {
    inspectorId: data.inspectorId,
    operatorId: data.operatorId,
    locationId: data.locationId,
    inspectionDate: data.inspectionDate,
    fields: data.fields || {},
  };

  const response = await LocationInspectionFormService.createLocationInspectionForm(body);

  if (!response.ok) {
    return {
      data: {
        error: response.data?.error || "Error createLocationInspectionFormHandler",
        message: response.data?.message,
        id: null,
        form: null,
      },
    };
  }

  return {
    data: {
      error: null,
      id: response.data?.id,
      form: response.data || null,
    },
  };
};

// ---------- GET BY ID: GET /api/location-inspection-form/{id} ----------
export const getLocationInspectionFormByIdHandler = async (id) => {
  const response = await LocationInspectionFormService.getLocationInspectionFormById(id);

  if (!response.ok) {
    return {
      data: {
        error: "Error getLocationInspectionFormByIdHandler",
        message: response.data?.message,
        form: null,
      },
    };
  }

  return {
    data: {
      error: null,
      form: response.data || null,
    },
  };
};

// ---------- EDIT: PUT /api/location-inspection-form/{id} ----------
export const editLocationInspectionFormByIdHandler = async (id, data) => {
  const body = {
    locationId: data.locationId,
    operatorId: data.operatorId,
    inspectionDate: data.inspectionDate,
    fields: data.fields || {},
    status: data.status,
  };

  const response = await LocationInspectionFormService.editLocationInspectionFormById(id, body);

  if (!response.ok) {
    return {
      data: {
        error: "Error editLocationInspectionFormByIdHandler",
        message: response.data?.message,
        form: null,
      },
    };
  }

  return {
    data: {
      error: null,
      form: response.data || null,
      message: response.data?.message || "Success",
    },
  };
};

// ---------- DELETE: DELETE /api/location-inspection-form/{id} ----------
export const deleteLocationInspectionFormByIdHandler = async (id) => {
  const response = await LocationInspectionFormService.deleteLocationInspectionFormById(id);

  if (!response.ok) {
    return {
      data: {
        error: "Error deleteLocationInspectionFormByIdHandler",
        message: response.data?.message,
        errorCode: response.data?.errorCode ?? null,
        ok: false,
      },
    };
  }

  return {
    data: {
      error: null,
      ok: true,
    },
  };
};

// ---------- OPERATOR DROPDOWN: GET /api/company-employees/company/{companyId} ----------
export const getCompanyWorkersHandler = async (companyId) => {
  const response = await getAllEmployeesFromCompany(companyId);

  if (!response.ok) {
    return {
      data: {
        error: "Error getCompanyWorkersHandler",
        message: response.data?.message,
        options: [],
      },
    };
  }

  const options = (response.data || [])
    .filter((employee) => employee?.type === TYPES.WORKER)
    .map((employee) => ({
      value: String(employee.id),
      label: `${employee.firstName || ""} ${employee.lastName || ""}`.trim() || String(employee.id),
      clockingLocations: (employee.clockingLocations || []).map(String),
    }))
    .sort((a, b) => a.label.localeCompare(b.label));

  return {
    data: {
      error: null,
      options,
    },
  };
};

// ---------- LOCATION DROPDOWN: GET /api/company-locations/user-locations ----------
export const getInspectionUserLocationsHandler = async () => {
  const response = await getUserLocations();

  if (!response.ok) {
    return {
      data: {
        error: "Error getInspectionUserLocationsHandler",
        message: response.data?.message,
        items: [],
      },
    };
  }

  return {
    data: {
      error: null,
      items: response.data || [],
    },
  };
};
